import { useState } from "react";
import {
  Select,
  InputLabel,
  MenuItem as MuiMenuItem,
  FormControl,
  SelectChangeEvent,
} from "@mui/material";
import useCss from "../../hooks/useCss";
import styles from "./styles";
import type { ReactNode } from "react";

export interface MenuItem {
  value: string;
  name: string | ReactNode;
  [key: string]: unknown;
}

interface Props {
  menuItems?: MenuItem[];
  value?: string;
  defaultValue?: string;
  handleSelectChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  label?: ReactNode;
  required?: boolean;
  menuMaxHeight?: number;
  autoFocus?: boolean;
}

const SbuxSelect = ({
  menuItems,
  value,
  defaultValue,
  handleSelectChange,
  disabled = false,
  className,
  label,
  required,
  menuMaxHeight,
  autoFocus = false,
}: Props) => {
  const classes = useCss(styles);
  const [localValue, setLocalValue] = useState(defaultValue || "");

  const isControlled = value !== undefined && handleSelectChange !== undefined;

  const handleOnChange = (event: SelectChangeEvent) => {
    const newValue = event.target.value;
    if (!isControlled) {
      setLocalValue(newValue);
    }

    handleSelectChange(newValue);
  };

  const getMenuItems = () => {
    return (
      menuItems &&
      menuItems.length > 0 &&
      menuItems.map((item, index) => (
        <MuiMenuItem
          sx={{
            fontSize: 14,
          }}
          key={index}
          className={classes.menuItem}
          value={item.value}
        >
          {item.name}
        </MuiMenuItem>
      ))
    );
  };

  const inputLabel = !!label ? (
    <InputLabel shrink>{label}</InputLabel>
  ) : undefined;

  return (
    <FormControl required={required} size="small" fullWidth>
      {inputLabel}
      <Select
        sx={{ maxHeight: 31 }}
        value={isControlled ? value : localValue}
        onChange={handleOnChange}
        disabled={disabled}
        className={className}
        autoFocus={autoFocus}
        MenuProps={
          menuMaxHeight
            ? {
                PaperProps: {
                  style: { maxHeight: menuMaxHeight, overflowY: "auto" },
                },
              }
            : undefined
        }
      >
        {getMenuItems()}
      </Select>
    </FormControl>
  );
};

export default SbuxSelect;
